var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6509_6753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6446 7.78924C16.6446 7.67138 16.5482 7.57495 16.4303 7.57495L14.6625 7.58299L12 10.7571L9.34017 7.58567L7.56963 7.57763C7.45178 7.57763 7.35535 7.67138 7.35535 7.79192C7.35535 7.84281 7.3741 7.89102 7.40624 7.9312L10.8911 12.083L7.40624 16.2321C7.37387 16.2714 7.35591 16.3205 7.35535 16.3714C7.35535 16.4892 7.45178 16.5857 7.56963 16.5857L9.34017 16.5776L12 13.4035L14.6598 16.575L16.4277 16.583C16.5455 16.583 16.642 16.4892 16.642 16.3687C16.642 16.3178 16.6232 16.2696 16.5911 16.2294L13.1116 12.0803L16.5964 7.92852C16.6286 7.89102 16.6446 7.84013 16.6446 7.78924Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.0268555C5.37321 0.0268555 0 5.40007 0 12.0269C0 18.6536 5.37321 24.0269 12 24.0269C18.6268 24.0269 24 18.6536 24 12.0269C24 5.40007 18.6268 0.0268555 12 0.0268555ZM12 21.9911C6.49821 21.9911 2.03571 17.5286 2.03571 12.0269C2.03571 6.52507 6.49821 2.06257 12 2.06257C17.5018 2.06257 21.9643 6.52507 21.9643 12.0269C21.9643 17.5286 17.5018 21.9911 12 21.9911Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6509_6753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseItem);
export default __webpack_public_path__ + "static/media/close-item.de6d01c95f53804482266e1c573b6e99.svg";
export { ForwardRef as ReactComponent };